//
// Module for the Create Account page
//
rs.module("content/user/account/create",

    [
        "common/select-helper",
    ],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors) {

            var form = $.js(jsSelectors.form);
            var countrySelect = form.js(jsSelectors.countrySelect);
            var homeZipCodeInput = form.js(jsSelectors.homeZipCodeInput);
            var challengeQuestionSelect1 = form.js(jsSelectors.challengeQuestionSelect1);
            var challengeQuestionSelect2 = form.js(jsSelectors.challengeQuestionSelect2);

            countrySelect.change(function () {
                homeZipCodeInput.clearErrors();
            });

            disableSelectedQuestionInOtherList();

            // Disable question 1 in Question 2's select list
            challengeQuestionSelect1.change(function () {
                disableSelectedQuestionInOtherList();
            });

            // Disable question 2 in Question 1's select list
            challengeQuestionSelect2.change(function () {
                disableSelectedQuestionInOtherList();
            });

            // Helper function to disable a selected challenge question in the other question's select list
            function disableSelectedQuestionInOtherList() {
                selectHelper.getHelper(challengeQuestionSelect1).enableAllOptions().disableOptions([challengeQuestionSelect2.val()]);
                selectHelper.getHelper(challengeQuestionSelect2).enableAllOptions().disableOptions([challengeQuestionSelect1.val()]);
            }

        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);